import { render, staticRenderFns } from "./tiktokOrder.vue?vue&type=template&id=746d23cc&scoped=true&"
import script from "./tiktokOrder.vue?vue&type=script&lang=js&"
export * from "./tiktokOrder.vue?vue&type=script&lang=js&"
import style0 from "./tiktokOrder.vue?vue&type=style&index=0&id=746d23cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "746d23cc",
  null
  
)

export default component.exports